const sliderLogos = $('.logo-strip .slider-logos');

if (sliderLogos.length) {
    sliderLogos.liMarquee({
        scrollStop: false,
        circular: true,
        startShow: true,
        hoverStop: false,
        dragAndDrop: false
    });
}